<template>
  <div>
    <h1>Show</h1>
    <div>
      <pre>{{ measure | pretty_json }}</pre>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState("measures", ["measure"]),
  },
  methods: {
    ...mapActions("measures", ["ActionShow"]),
  },
  async created() {
    await this.ActionShow({id: this.$route.params.id});
  },
};
</script>

<style>
</style>
